// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-btn[data-v-5a51a68d] {\n  text-transform: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
